module.exports = __webpack_public_path__ + "static/media/ma-communication.370277ce.svg";